import type { FetchBookmarksMeta, ToggleBookmarkMeta } from "domains/bookmarks/types";
import type { Cluster } from "domains/clusters/types";
import type { KnowledgeResponse } from "entities/knowledge/types";

export enum BookmarkActionTypes {
  BOOKMARKS_FETCH_FULFILLED = "[Bookmarks] BOOKMARKS_FETCH_FULFILLED",
  BOOKMARKS_FETCH_REJECTED = "[Bookmarks] BOOKMARKS_FETCH_REJECTED",
  BOOKMARK_TOGGLE_FULFILLED = "[Bookmarks] BOOKMARK_TOGGLE_FULFILLED",
  BOOKMARK_TOGGLE_REJECTED = "[Bookmarks] BOOKMARK_TOGGLE_REJECTED",
}

type BookmarkPayload = { bookmarks: (Cluster | KnowledgeResponse)[]; total: number };

type BookmarksFetchFulfilledAction = {
  meta: FetchBookmarksMeta;
  payload: BookmarkPayload;
  type: BookmarkActionTypes.BOOKMARKS_FETCH_FULFILLED;
};

type BookmarksFetchRejectedAction = {
  meta: FetchBookmarksMeta;
  type: BookmarkActionTypes.BOOKMARKS_FETCH_REJECTED;
};

export type ToggleBookmarkFulfilledAction = {
  meta: ToggleBookmarkMeta;
  type: BookmarkActionTypes.BOOKMARK_TOGGLE_FULFILLED;
};

export type BookmarksAction =
  | BookmarksFetchFulfilledAction
  | BookmarksFetchRejectedAction
  | ToggleBookmarkFulfilledAction;
